   
  import { Component } from '@angular/core';
   
  @Component({
    selector: 'auction-spinner',
    template: `
      <div class="spinner-overlay">
        <div class="spinner"></div>
      </div>
    `,
    styles: [
      `
        .spinner-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 20000;
        }
   
        .spinner {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #3498db;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          animation: spin 1s linear infinite;
        }
   
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `,
    ],
    standalone:true
  })
  export class AuctionSpinnerComponent {}
   
   